import React, { useContext, useEffect } from 'react';
import {
  Box, Container, Divider, IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBackRounded } from '@mui/icons-material';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';
import Fragments from '../../../Fragments';
import { getWallet } from '../../../../Redux/Models/user';
import { getUserData } from '../../../../Utils/storages';

export default function Component({
  classes, error, message, wallet,
}) {
  const user = getUserData();
  const navigate = useNavigate();
  const { openAlert } = useContext(AlertContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getWallet(user.id));
  }, []);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Box className={classes.root}>
        <Box bgcolor={Colors.primary} py={3}>
          <Container>
            <Box color="#FDFDFD" display="flex" alignItems="center">
              <Box flex={1}>
                <IconButton sx={{ p: 0 }} onClick={() => navigate('/')}>
                  <ArrowBackRounded sx={{ color: '#FDFDFD' }} />
                </IconButton>
              </Box>
              <Box className="weight-700">
                Oenowallet
              </Box>
              <Box flex={1} />
            </Box>
            <Box mt={3} bgcolor="#FDFDFD" borderRadius="10px" p={1.5}>
              <Box display="flex" justifyContent="space-between" alignItems="center" gap={3}>
                <Box border="1px solid #E5E5E5" borderRadius="5px" py={1} px={1.5} flex={1}>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <img src={Images.MyBalance} alt="my balance" />
                    <div className="s-10 mute">My balance</div>
                  </Box>
                  <div className="weight-600 mt-1">{wallet?.amount || 'Top up first'}</div>
                </Box>
                {/* <Box textAlign="center" className="link">
                  <img src={Images.OenoTopup} alt="topup" />
                  <div className="s-10 weight-600">Top up</div>
                </Box> */}
              </Box>
            </Box>
          </Container>
        </Box>

        {/* <Box display="flex" justifyContent="space-evenly" alignItems="center" gap={3} mt={2}>
          <Box textAlign="center" className="link" component={Link} to="withdraw">
            <img width="28px" height="28px" src={Images.OenoWithdraw} alt="topup" />
            <div className="s-10 weight-600 black">Withdraw</div>
          </Box>
          <Box textAlign="center" className="link" component={Link} to="history">
            <img width="28px" height="28px" src={Images.IconHistory} alt="topup" />
            <div className="s-10 weight-600 black">History</div>
          </Box>
          <Box textAlign="center" className="link" component={Link} to="help">
            <img width="28px" height="28px" src={Images.OenoHelp} alt="topup" />
            <div className="s-10 weight-600 black">Help center</div>
          </Box>
        </Box> */}

        <Box mt={3}>
          <Fragments.InformationCarousel />
        </Box>

        <Box mt={3}>
          <Container>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <div className="weight-700 ">Last transaction</div>
                <div className="s-10 mute">Here&apos;s your last transaction</div>
              </Box>
              <Box className="link primary-green weight-600 s-12" alignSelf="flex-end">See all</Box>
            </Box>
            <Box>
              {wallet?.data?.length
                ? wallet?.data?.map((item) => (
                  <>
                    <Box className="weight-700" mt={2}>{moment(item.date).format('dddd, MMM Do YYYY')}</Box>
                    <Box display="flex" gap={1} mt={2} pl={1}>
                      <img alt="icon" src={Images.OenoMarket} width="16" height="16" />
                      <Box flex={1}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <Box>
                            <div className="s-12 weight-700">{item.status}</div>
                            <div className="s-12">Oenowallet</div>
                          </Box>
                          {
                            item.status.toLowerCase() === 'transaction in' ? (
                              <Box className="weight-700" color="#38AC3D">
                                +₣
                                {item.amount}
                              </Box>
                            ) : (
                              <Box className="weight-700">
                                -₣
                                {item.amount}
                              </Box>
                            )
                          }

                        </Box>
                        <Divider sx={{ mt: 2 }} />
                      </Box>
                    </Box>
                  </>
                ))
                : <Box fontSize={12} mt={2}>No transaction history</Box>}
            </Box>
          </Container>
        </Box>

      </Box>
      <Elements.Footer />
    </Elements.PageBase>
  );
}
